import React from "react";
import I18n from "i18n-js";
import IconTooltip from "./IconTooltip";
import { getHtmlElement, parseUserFullName, titleize } from "../../utils/utils";

const Address = ({
  address,
  email,
  note,
  hidePhoneNumber,
  displayFullNotes,
  renderResidence,
  hideUserGeneralities,
  renderCopyButton,
  renderTitle,
  locale,
  addressType
}) => {


  const CopyButton = ({ id }) => {
    const handleClickCopyButton = (htmlElementId) => {
      navigator.clipboard.writeText(getHtmlElement(document, htmlElementId).innerText).then(() => { }).catch(err => { })
    }

    return <React.Fragment>
      {
        renderCopyButton &&
        <button
          className="btn btn-xs btn-info my-1px ml-2 mr-0"
          onClick={() => handleClickCopyButton(id)}>
          <i className="fas fa-fw fa-copy" />
        </button>
      }
    </React.Fragment>
  }

  const RenderTitle = ({ title, fragment }) => {
    if (renderTitle) {
      return (
        <div className="row">
          <div className="col-6">
            <b>
              {title}
            </b>
          </div>
          <div className="col-6">
            {fragment}
          </div>
        </div>
      )
    } else {
      return (
        <React.Fragment>
          {fragment}
          <br />
        </React.Fragment>
      )
    }
  }


  return <React.Fragment>
    {
      !hideUserGeneralities &&
      <React.Fragment>
        {
          address?.residence && renderResidence &&
          <React.Fragment>
            <RenderTitle
              title=''
              fragment={
                <React.Fragment>
                  <b id={`residence_${addressType}`} className="mb-0">
                    {I18n.t('js.newUserAddressForm.residenceCompact')}
                  </b>
                </React.Fragment>
              }
            />
          </React.Fragment>
        }

        <RenderTitle
          title='Generalities'
          fragment={
            <React.Fragment>
              <span className="mb-0" id={`user_generalities_${addressType}`}>
                {parseUserFullName(address?.first_name, address?.last_name)}
                {
                  address?.co &&
                  <React.Fragment>
                    &nbsp;
                    <span className="mb-0">
                      {I18n.t('js.newUserAddressForm.co', { locale: locale ? locale : I18n.locale })} {address?.co}
                    </span>
                  </React.Fragment>
                }
              </span>
              <CopyButton id={`user_generalities_${addressType}`} />
            </React.Fragment>
          }
        />
      </React.Fragment >
    }

    <RenderTitle
      title='Address'
      fragment={
        <React.Fragment>
          <span className="mb-0" id={`street_${addressType}`}>
            {titleize(address?.street_square) + ' ' + address?.number}{address?.indoor ? (' ' + I18n.t('js.newUserAddressForm.indoor', { locale: locale ? locale : I18n.locale }) + ' ' + address?.indoor) : ''}
          </span>
          <CopyButton id={`street_${addressType}`} />
        </React.Fragment>
      }
    />

    <RenderTitle
      title='Cap/City - Province/Country'
      fragment={
        <React.Fragment>
          <span className="mb-0" id={`cap_${addressType}`}>
            {address?.cap}
          </span>
          <CopyButton id={`cap_${addressType}`} />
          <span className="mb-0 ml-2" id={`city_${addressType}`}>
            {(address?.city?.toUpperCase() !== address?.province?.toUpperCase() ? titleize(address?.city) + ' - ' : '') + address?.province?.toUpperCase()}
          </span>
          <CopyButton id={`city_${addressType}`} />
          {
            address?.country?.toUpperCase() !== address?.province?.toUpperCase() &&
            <React.Fragment>
              <span className="mb-0 ml-2" id={`country_${addressType}`}>
                ({address?.country?.toUpperCase()})
              </span>
              <CopyButton id={`country_${addressType}`} />
            </React.Fragment>
          }
        </React.Fragment>
      }
    />

    {
      address?.phone_number && !hidePhoneNumber &&
      <React.Fragment>
        <RenderTitle
          title='Phone Number'
          fragment={
            <React.Fragment>
              <span id={`phone_number_${addressType}`}>
                {address?.phone_number}
              </span>
              <CopyButton id={`phone_number_${addressType}`} />
            </React.Fragment>
          }
        />
      </React.Fragment>
    }


    {
      (address?.email || email) &&
      <React.Fragment>
        <RenderTitle
          title='Email'
          fragment={
            <React.Fragment>
              <span id={`email_${addressType}`}>
                {address?.email ? address?.email : email}
              </span>
              <CopyButton id={`email_${addressType}`} />
            </React.Fragment>
          }
        />
      </React.Fragment>
    }


    {
      note &&
      <React.Fragment>
        <RenderTitle
          title='Notes'
          fragment={
            displayFullNotes ?
              <React.Fragment>
                <span id={`note_${addressType}`}>
                  {I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })} {note}
                </span>
                <CopyButton id={`note_${addressType}`} />
              </React.Fragment>
              :
              <React.Fragment>
                <span id={`note_${addressType}`}>
                  <small>{I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })}</small>
                  <IconTooltip
                    tooltipPosition={'top'}
                    tooltipIcon={'fas fa-comment'}
                    tooltipTitle={''}
                    tooltipContent={note}
                    additionalClassesForIcon={'black'}
                  />
                </span>
                <CopyButton id={`note_${addressType}`} />
              </React.Fragment>
          }
        />
      </React.Fragment>
    }
  </React.Fragment >
};

export default Address;